export default __webpack_public_path__ + "static/media/DNo.16-3.f478ce87.jpg";